import { useCurrency } from '../context/CurrencyContext';

/**
 * Displays a price converted + formatted into the buyer's preferred currency.
 *
 * @param {number} amountEur  - Price in EUR (the platform's base currency)
 * @param {string} className  - Optional className for styling
 * @param {string} testId     - Optional data-testid
 * @param {string} as         - Element tag (default 'span')
 * @param {boolean} showOriginalTooltip - If true, hover shows the €-original amount
 */
export default function Price({ amountEur, className = '', testId, as = 'span', showOriginalTooltip = true, ...rest }) {
  const { formatPrice, currency } = useCurrency();
  const Tag = as;
  const formatted = formatPrice(amountEur);
  const tooltip = showOriginalTooltip && currency !== 'EUR'
    ? `Original: €${Number(amountEur || 0).toFixed(2)}`
    : undefined;
  return (
    <Tag
      className={className}
      data-testid={testId}
      title={tooltip}
      {...rest}
    >
      {formatted}
    </Tag>
  );
}
